export class FetchNotifications {
  static readonly type = '[Toolbar Notifications Component] Fetch Notifications';
}
